import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Radio, Row, Card, Form, Button } from "antd";

class TransactionTypeFieldSet extends Component {

  handleChange = (e) => {
    this.props.updateTransactionType({ transactionType: e.target.value });
  };


  render() {
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
      // fontWeight: "700",
    };

    const { getFieldDecorator } = this.props.form;

    return (
      <Card className="role-container-type" bordered={false}>
        <h4
          style={{
            margin: "4px 0px 8px",
            color: "#43637c",
            fontWeight: "500",
            fontSize: "16px",
          }}
        >
          Role in Transaction
        </h4>
        <Form>
          <Row style={{marginBottom:"0px"}}>
            <Form.Item style={{marginBottom:"0px"}}>
             {getFieldDecorator("customer_type", {
              initialValue: this.props.transaction_type,
              rules: [
                  {
                   required: false,
                   message: "Please input customer type",
                  },
                ],
              })(
              <Radio.Group onChange={this.handleChange}>
                <Radio style={radioStyle} value={"Importer"}>
                  Importer / Receiver
                </Radio>
                <Radio style={radioStyle} value={"Exporter"}>
                  Exporter / Shipper
                </Radio>
              </Radio.Group>
              )}
            </Form.Item>
          </Row>
        </Form>
      </Card>
    );
  }
}

const TransactionType = Form.create({ name: 'transactio_type' })(
  TransactionTypeFieldSet
);

const mapStateToProps = (state) => {
  return {
   transaction_type: state.code_config.transactionType,
  };
};

export default connect(mapStateToProps, actions)(TransactionType);